import { logError, Logger } from '~/util/logger';

import { Renderer } from '~/models/Contensis';
import ContensisRepository from '~/repositories/ContensisRepository';

class RenderersService {
  private contensis: ContensisRepository;
  private source: ContensisRepository;
  error: AppError | null = null;
  raw: Renderer[] = [];

  constructor(contensis: ContensisRepository, source: ContensisRepository) {
    this.contensis = contensis;
    this.source = source;
  }

  GetRenderers = async (): Promise<[AppError | null, Renderer[]]> => {
    Logger.info(
      `[renderers] ${this.contensis.alias} | Getting renderers in ${this.contensis.projectId}`
    );
    const [err, renderers] = await this.contensis.repo.GetRenderers<
      Renderer[]
    >();

    if (err) logError(err);
    else this.raw = renderers || [];

    return [err, this.raw];
  };
}

export default RenderersService;
